<template>
  <div id="updateBlacklistDialog">
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="closeDialog"
    >
      <DForm
        ref="formRef"
        :formItems="formItems"
        :model="formData"
        label-width="110px"
      />
      <div class="footBtn">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProJectList } from "@/api/ozBlockConf";

function createDefaultFormData() {
  return {
    id: "",
    appName: "",
    packageName: "",
    customerId: "",
    channelId: "",
    projectIds: [],
    remarks: "",
  };
}

export default {
  name: "UpdateBlacklistAddEditDialog",
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      },
    },
    dialogName: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    formItems() {
      return [
        {
          label: "应用名称",
          prop: "appName",
          type: "Input",
          span: 24,
          required: true,
          props: {
            maxlength: 100,
          },
        },
        {
          label: "应用包名",
          prop: "packageName",
          type: "Input",
          span: 24,
          required: true,
          props: {
            maxlength: 200,
          },
        },
        {
          label: "客户号",
          prop: "customerId",
          type: "Select",
          span: 24,
          required: true,
          props: {
            filterable: true,
            clearable: true,
            options: this.customerList.map((item) => ({
              label: item.cusNo,
              value: item.cusNo,
            })),
          },
          events: {
            change: this.handleCustomerChange,
          },
        },
        {
          label: "渠道号",
          prop: "channelId",
          type: "Select",
          span: 24,
          required: true,
          props: {
            filterable: true,
            clearable: true,
            disabled: !this.formData.customerId,
            options: this.channelList.map((item) => ({
              label: item.channelName,
              value: item.channelName,
            })),
          },
          events: {
            change: this.handleChannelChange,
          },
        },
        {
          label: "项目号",
          prop: "projectIds",
          type: "Select",
          span: 24,
          props: {
            multiple: true,
            filterable: true,
            clearable: true,
            collapseTags: true,
            disabled: !this.formData.channelId,
            options: this.projectList.map((item) => ({
              label: item.projectName,
              value: item.projectName,
            })),
          },
          rules: [
            {
              required: true,
              type: "array",
              message: "请选择项目号",
              trigger: "change",
            },
          ],
        },
        {
          label: "备注",
          prop: "remarks",
          type: "Input",
          span: 24,
          props: {
            type: "textarea",
            rows: 3,
            maxlength: 200,
          },
        },
      ];
    },
  },
  data() {
    return {
      dialogVisible: false,
      customerList: [],
      channelList: [],
      projectList: [],
      formData: createDefaultFormData(),
    };
  },
  methods: {
    async init() {
      this.dialogVisible = true;
      this.customerList = await this.getOptions({ type: 1 });
      this.$nextTick(async () => {
        this.formData = this.normalizeRowData(this.rowData);
        this.channelList = [];
        this.projectList = [];
        if (this.formData.customerId) {
          this.channelList = await this.getOptions({
            cusNo: this.formData.customerId,
            type: 2,
          });
        }
        if (this.formData.customerId && this.formData.channelId) {
          this.projectList = await this.getOptions({
            cusNo: this.formData.customerId,
            channelName: this.formData.channelId,
            type: 3,
          });
        }
      });
    },
    normalizeRowData(row = {}) {
      const formData = createDefaultFormData();
      if (this.dialogName === "新增") {
        return formData;
      }
      const projectIds = Array.isArray(row.projectIds)
        ? row.projectIds
        : row.projectId
        ? [row.projectId]
        : row.projectName
        ? [row.projectName]
        : [];
      return {
        ...formData,
        ...row,
        appName: row.appName || row.name || "",
        packageName: row.packageName || row.appPackageName || row.pname || "",
        customerId: row.customerId || row.cusNo || "",
        channelId: row.channelId || row.channelName || "",
        projectIds,
        remarks: row.remarks || row.remark || "",
      };
    },
    async handleCustomerChange(value) {
      this.formData.channelId = "";
      this.formData.projectIds = [];
      this.channelList = [];
      this.projectList = [];
      if (!value) {
        return;
      }
      this.channelList = await this.getOptions({
        cusNo: value,
        type: 2,
      });
    },
    async handleChannelChange(value) {
      this.formData.projectIds = [];
      this.projectList = [];
      if (!value || !this.formData.customerId) {
        return;
      }
      this.projectList = await this.getOptions({
        cusNo: this.formData.customerId,
        channelName: value,
        type: 3,
      });
    },
    async getOptions(params) {
      const res = await getProJectList({ page: 1, size: 3000, ...params });
      if (res && res.code === 0) {
        return res.data.list || [];
      }
      return [];
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        const payload = {
          ...this.formData,
          appPackageName: this.formData.packageName,
          remark: this.formData.remarks,
          projectId: this.formData.projectIds[0] || "",
          projectIdList: [...this.formData.projectIds],
          projectIds: [...this.formData.projectIds],
        };
        this.$emit("submitBtn", this.dialogName === "新增", payload);
        this.dialogVisible = false;
        return true;
      });
    },
    closeDialog() {
      this.formData = createDefaultFormData();
      this.$refs.formRef.clearValidate();
      this.channelList = [];
      this.projectList = [];
    },
  },
};
</script>

<style scoped lang="scss">
#updateBlacklistDialog {
  .footBtn {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }
}
</style>
